<template>
  <div class="help">
    <div class="center">
      <div class="help-wrap">敬请期待！</div>
    </div>
  </div>
</template>

<style lang="scss">
.help {
  .center {
    max-width: 1200px;
    margin: 40px auto;
    text-align: center;
    color: #999;
    padding: 15px;
    .help-wrap {
      background-color: #162642;
      min-height: 500px;
      padding: 15px;
    }
  }
}

@media screen and (max-width: 992px) {
  .help {
    .center {
      .help-wrap {
        min-height: 400px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .help {
    .center {
      .help-wrap {
        min-height: 300px;
      }
    }
  }
}
</style>